import { GroupTraitItem } from '@kp/traits/group-trait-item.model';
import { setTraitType, TraitType } from '@kp/traits/trait-type.enum';

export class GroupTrait {
  constructor(public type?: TraitType, public traits?: GroupTraitItem[]) {}

  deserialize(input: any): GroupTrait {
    if (input == null) {
      return null;
    }
    this.type = setTraitType(input.type);
    this.traits = input.traits.map((trait) => new GroupTraitItem().deserialize(trait));
    return this;
  }
}
